import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['card', 'h-100'])
}
const _hoisted_2 = { class: "card-header timeline-header" }
const _hoisted_3 = { class: "time-display" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "card-body timeline-body" }
const _hoisted_6 = { class: "card-title bold" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  class: "card-text hosted-by"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "card-footer timeline-footer"
}
const _hoisted_11 = { class: "text-muted" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 1,
  class: "col-lg-4 col-md-6 col-12 mediathek"
}
const _hoisted_18 = { class: "card-body p-0" }
const _hoisted_19 = { style: {"padding":"1rem"} }
const _hoisted_20 = { class: "card-title bold" }
const _hoisted_21 = { class: "card-header timeline-header" }
const _hoisted_22 = { class: "time-display" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "card-body timeline-body" }
const _hoisted_25 = { class: "card-title bold" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  key: 1,
  class: "card-text hosted-by"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 0,
  class: "card-footer timeline-footer"
}
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = ["innerHTML"]

import { computed, ref, onMounted  } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import _ from 'lodash'
import type { AgendaPoint } from '@/store/i/types'
import type { TranslatedText } from '@/store/types'
import { networkErrorText, type AppNetworkErrorOther } from '@/crud'
import { DateTime } from 'luxon'
import IconWebcam from '@/components/icons/IconWebcam.vue'
import ImageWithFallback from "@/components/ImageWithFallback.vue";

// Props
interface Props {
  ae: AgendaPoint
  type?: number
  agendatype?: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AgendaEntry',
  props: {
    ae: {},
    type: {},
    agendatype: {}
  },
  setup(__props: any) {

const props = __props

// Store, Router & Route
const store = useStore()
const router = useRouter()
const route = useRoute()

// Reactive State
const errorstring = ref<TranslatedText>({ de: '', en: '' })

// Computed Properties
const isLoggedIn = computed(() => 
  store.state.jwt !== ""
)

const Include = computed(() =>
    _.has(store.state.i.me.fav_agenda_items, props.ae.objvalueid)
)

const Exclude = computed(() =>
    !_.has(store.state.i.me.fav_agenda_items, props.ae.objvalueid)
)

const title = computed(() => {
  const text = _.replace(props.ae.title || "", /&#34;/g, '"')
  return _.replace(text, /&#39;/g, "'")
})

const formatedFromTime = computed(() => {
  try {
    // Zuerst versuchen wir es mit fromtime
    if (props.ae.fromtime) {
      const dt = DateTime.fromISO(props.ae.fromtime, {zone: 'Europe/Berlin'});
      if (dt.isValid) {
        return dt.toFormat('HH:mm');
      }
    }
    
    // Wenn fromtime nicht funktioniert, verwenden wir startdate
    if (props.ae.startdate) {
      const dt = DateTime.fromISO(props.ae.startdate, {zone: 'Europe/Berlin'});
      if (dt.isValid) {
        return dt.toFormat('HH:mm');
      }
    }
    
    return '--:--';
  } catch (e) {
    return '--:--';
  }
})

const formatedToTime = computed(() => {
  try {
    // Zuerst versuchen wir es mit totime
    if (props.ae.totime) {
      const dt = DateTime.fromISO(props.ae.totime, {zone: 'Europe/Berlin'});
      if (dt.isValid) {
        return dt.toFormat('HH:mm');
      }
    }
    
    // Wenn totime nicht funktioniert, verwenden wir enddate
    if (props.ae.enddate) {
      const dt = DateTime.fromISO(props.ae.enddate, {zone: 'Europe/Berlin'});
      if (dt.isValid) {
        return dt.toFormat('HH:mm');
      }
    }
    
    return '--:--';
  } catch (e) {
    return '--:--';
  }
})

// Computed property für die Anzeige-Bedingung
const shouldShowEntry = computed(() => {
  // Wenn wir im Speaker-Detail sind (agendatype === 'entry'), 
  // dann nur anzeigen wenn show_area === 1
  if (props.agendatype === 'entry') {
    return Number(props.ae.show_area) === 1
  }
  // In allen anderen Fällen immer anzeigen
  return true
})

// Methods
const navigateAgenda = () => {
  router.push({
    name: 'AgendaDetail',
    params: { agendaid: `${props.ae.objvalueid}` }
  })
}

const setFav = async () => {
  try {
    errorstring.value = { de: '', en: '' }
    const dpr = await store.dispatch("i/setDataFav", {
      objvalueid: props.ae.objvalueid
    })
    if (!dpr.sv) {
      errorstring.value = {
        de: "Feld konnte nicht gesetzt werden.",
        en: "Could not set Field."
      }
    }
  } catch (e) {
    errorstring.value = networkErrorText(e as AppNetworkErrorOther)
  }
}

const unsetFav = async () => {
  try {
    errorstring.value = { de: '', en: '' }
    const dpr = await store.dispatch("i/setDataUnFav", {
      objvalueid: props.ae.objvalueid
    })
    if (!dpr.sv) {
      errorstring.value = {
        de: "Feld konnte nicht entfernt werden.",
        en: "Could not remove Field."
      }
    }
  } catch (e) {
    errorstring.value = networkErrorText(e as AppNetworkErrorOther)
  }
}

const generateFileICS = () => {
  window.location.href = `/projects/dw/gmf/sources/scripts/portal.php?&action=generateFileICS&objvalueid=${props.ae.objvalueid}`
}


return (_ctx: any,_cache: any) => {
  return (_ctx.agendatype === 'timeline')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([['timeline-card-wrapper', `et${_ctx.ae.eventtype}`], "pointer"]),
        onClick: navigateAgenda
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (isLoggedIn.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (Include.value)
                    ? (_openBlock(), _createElementBlock("small", {
                        key: 0,
                        class: "text-muted action-icon",
                        title: "Bookmark",
                        onClick: _withModifiers(unsetFav, ["stop"])
                      }, _cache[0] || (_cache[0] = [
                        _createElementVNode("i", { class: "fal fa-calendar-plus" }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (Exclude.value)
                    ? (_openBlock(), _createElementBlock("small", {
                        key: 1,
                        class: "text-muted action-icon",
                        title: "Bookmark",
                        onClick: _withModifiers(setFav, ["stop"])
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("i", { class: "fal fa-calendar-minus" }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createElementVNode("small", {
                    class: "text-muted action-icon",
                    title: "ICS Download",
                    onClick: _withModifiers(generateFileICS, ["stop"])
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1)
                  ]))
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("small", _hoisted_3, _toDisplayString(formatedFromTime.value) + " - " + _toDisplayString(formatedToTime.value), 1),
            (_ctx.ae.stream)
              ? (_openBlock(), _createElementBlock("small", _hoisted_4, [
                  _createVNode(IconWebcam, {
                    title: "Stream available",
                    style: {"height":"1rem"}
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(title.value), 1),
            (_ctx.ae.subtitle)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "card-subtitle",
                  innerHTML: _ctx.ae.subtitle
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.ae.hosted_by)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createTextVNode(" Hosted by: ")),
                  _createElementVNode("span", {
                    innerHTML: _ctx.ae.hosted_by
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.ae.room || _ctx.ae.location)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("small", _hoisted_11, [
                  (_ctx.ae.room)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                        _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fal fa-map-marker-alt" }, null, -1)),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("span", {
                          innerHTML: _ctx.ae.room
                        }, null, 8, _hoisted_13)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.ae.room && _ctx.ae.location)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " - "))
                    : _createCommentVNode("", true),
                  (_ctx.ae.location)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.ae.location
                        }, null, 8, _hoisted_16)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : (_ctx.agendatype === 'video' || _unref(route).name === 'Mediathek')
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", {
            class: _normalizeClass(`card mb-3 et${_ctx.ae.eventtype}`)
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("a", {
                onClick: navigateAgenda,
                class: "pointer"
              }, [
                _createVNode(ImageWithFallback, {
                  alt: "Preview-Image",
                  style: {"width":"100%"},
                  src: `/files/agenda_items/${_ctx.ae.objvalueid}/preview.jpg`
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString(title.value), 1)
                ])
              ])
            ])
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({
    /* Spalten nur für Listenansicht, nicht im Accordion */
    'col-lg-9 col-12': _ctx.agendatype !== 'accordion-timeline' 
  })
        }, [
          (shouldShowEntry.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([['card', 'mb-3', `et${_ctx.ae.eventtype}`], "pointer"]),
                onClick: navigateAgenda
              }, [
                _createElementVNode("div", _hoisted_21, [
                  (isLoggedIn.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (Include.value)
                          ? (_openBlock(), _createElementBlock("small", {
                              key: 0,
                              class: "text-muted action-icon",
                              title: "Bookmark",
                              onClick: _withModifiers(unsetFav, ["stop"])
                            }, _cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "fal fa-calendar-plus" }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        (Exclude.value)
                          ? (_openBlock(), _createElementBlock("small", {
                              key: 1,
                              class: "text-muted action-icon",
                              title: "Bookmark",
                              onClick: _withModifiers(setFav, ["stop"])
                            }, _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "fal fa-calendar-minus" }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createElementVNode("small", {
                          class: "text-muted action-icon",
                          title: "ICS Download",
                          onClick: _withModifiers(generateFileICS, ["stop"])
                        }, _cache[8] || (_cache[8] = [
                          _createElementVNode("i", { class: "fal fa-calendar-check" }, null, -1)
                        ]))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("small", _hoisted_22, _toDisplayString(formatedFromTime.value) + " - " + _toDisplayString(formatedToTime.value), 1),
                  (_ctx.ae.stream)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_23, [
                        _createVNode(IconWebcam, {
                          title: "Stream available",
                          style: {"height":"1rem"}
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString(title.value), 1),
                  (_ctx.ae.subtitle)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "card-subtitle",
                        innerHTML: _ctx.ae.subtitle
                      }, null, 8, _hoisted_26))
                    : _createCommentVNode("", true),
                  (_ctx.ae.hosted_by)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                        _cache[9] || (_cache[9] = _createTextVNode(" Hosted by: ")),
                        _createElementVNode("span", {
                          innerHTML: _ctx.ae.hosted_by
                        }, null, 8, _hoisted_28)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.ae.room || _ctx.ae.location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _createElementVNode("small", _hoisted_30, [
                        (_ctx.ae.room)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fal fa-map-marker-alt" }, null, -1)),
                              _cache[11] || (_cache[11] = _createTextVNode()),
                              _createElementVNode("span", {
                                innerHTML: _ctx.ae.room
                              }, null, 8, _hoisted_32)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.ae.room && _ctx.ae.location)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, " - "))
                          : _createCommentVNode("", true),
                        (_ctx.ae.location)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _createElementVNode("span", {
                                innerHTML: _ctx.ae.location
                              }, null, 8, _hoisted_35)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true)
        ], 2))
}
}

})